import React, { MouseEvent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Body } from '@routific/hive';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  order: 2;
  z-index: 999;
  text-align: center;

  & > div {
    padding: 1.25rem 1.25rem 1.25rem;
  }
`;

const Inner = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

interface Props extends PropsWithChildren {
  onClick?: React.MouseEventHandler;
  label?: string;
}

const PanelCollapsed: React.FC<Props> = ({
  onClick, label,
  children, ...props
}) => {
  const handleChildrenClick = (e: MouseEvent<HTMLDivElement> & { target: HTMLDivElement }) => {
    const isClickingInButton = e.target.nodeName === 'BUTTON';
    const isClickingInChild = e.target.parentElement?.parentNode?.nodeName === 'BUTTON' || !e.target.closest('#root');

    // prevent toggling open if button or child node
    if (isClickingInButton || isClickingInChild) {
      e.stopPropagation();
    }
  };
  return (
    <Wrapper className="panel-collapsed" onClick={onClick} {...props}>
      <div>
        <Body style={{ fontWeight: 500 }}>{label}</Body>
        <Inner onClick={handleChildrenClick}>
          {children}
        </Inner>
      </div>
    </Wrapper>
  );
};

export default PanelCollapsed;
